<div markdown src="assets/md/legal/terms/terms_{{version()}}.md"></div>
